/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Trust_SetupInputs */

const es_home_hero_trust_setup = /** @type {(inputs: Home_Hero_Trust_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración en minutos`)
};

const en_home_hero_trust_setup = /** @type {(inputs: Home_Hero_Trust_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup in minutes`)
};

/**
* | output |
* | --- |
* | "Setup in minutes" |
*
* @param {Home_Hero_Trust_SetupInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_trust_setup = /** @type {((inputs?: Home_Hero_Trust_SetupInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Trust_SetupInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_trust_setup(inputs)
	return en_home_hero_trust_setup(inputs)
});
export { home_hero_trust_setup as "home.hero.trust_setup" }